module.exports = __webpack_public_path__ + "media/images/captive_portal/Color-Six-9a69108de87afa68dcdbe241f66a8107.png";